<template> 
  <section>
    <div class="container is-fluid 1 banner-section" >
      <div class="mask01"></div>
      <div class="pb-header" style="color: #F9FBFF;" >The requested page could not be found.</div>
      <div class="searchBar my-4">
        <b-autocomplete
            class="column is-12 pt-0 "
            v-model="searchInput"
            placeholder="Search a different keyword"
            icon="magnify"
            clearable
            @typing="filterAnnouncement('typing')"
            @select="filterAnnouncement('select')">
            <template #empty>No results found</template>
        </b-autocomplete>
      </div>
      <p class="bold-l2" style="padding-top: 15px; text-decoration-line:underline; color: #FFFFFF;"><a href="/" style="color: #FFFFFF">Click here to return to the homepage.</a></p>
    </div>
  </section>  
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  props: ['contentList', 'dropdownList'],
  data() {
    return {
      searchInput: ''
    }
  },
  methods: {
    filterAnnouncement: debounce(function (type) {
      let filteredList = [];
      if(this.searchInput === ''){
        filteredList = this.contentList;
      }
      else if(type === 'select'){
        filteredList = this.contentList.filter(i => i.attributes.title === this.searchInput);
      }else if(type === 'typing'){
        filteredList = this.contentList.filter((option) => {
          return option.attributes.title
            .toString()
            .toLowerCase()
            .indexOf(this.searchInput.toLowerCase()) >= 0
        })
      }
      this.$emit('set-content-array', filteredList);
    }, 500)  
  },
  // computed: {
  //   filteredDataArray() {
  //     return this.dropdownList.filter((option) => {
  //       return option
  //         .toString()
  //         .toLowerCase()
  //         .indexOf(this.searchInput.toLowerCase()) >= 0
  //     })
  //   }
  // }
}
</script>


<style lang="scss" scoped>
  .banner-section{
    background: url('../assets/img/banner/error404-banner.png') center;
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    margin-top: -10rem;
    min-height: 1080px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 0;
  }

  .mask01 {
    position: absolute;
    min-height: 1080px;
    z-index: -1;
    display: block;
    width: 100%;
  }

  .searchBar {
    width: 70%;
  }

  :deep(){
    .dropdown-content {
      background-color: white;
      text-align: left;
    }
    
    @media screen and (max-width: 1023px){
      .control.has-icons-right .icon.is-right{
        height: -webkit-fill-available;
        padding-right: 20px;
      }
      
      .control.has-icons-left .input, .icon.is-left {
        border-radius: 9px !important;
        font-weight: normal;
        font-size: inherit;
        color: #dbdbdb !important;
        padding-right: 20px !important;
      }
    }
  }

  @media (max-width: 768px) {
    .banner-section {
      background: url("../assets/img/banner-404-mobile.png") center center;
      background-repeat: no-repeat;
      background-size: cover;
      .mask01 {
        background: linear-gradient(98.46deg, #000220 -16.28%, rgba(0, 2, 32, 0) 135.02%);
        
      }
      p {
        font-size: 24px;
      }
      a {
        font-size: 1rem;
      }
    }

    .searchBar {
      width: 100%;
    }
    
  }
</style>
